export const titleSx = {
  fontSize: 'xs',
  color: 'textSubdued',
  wordBreak: 'break-word',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  whiteSpace: 'normal',
};
